import fetch from '../api/fetch'

/**
 * 	Action to fetch the notifications of the user
 *
 * 	@method GET
 */

export function getNotifications() {
    return {
        type: 'FETCH_GET_NOTIFICATIONS',
        payload: fetch(`/notification`, { method: 'GET' }),
    }
}

/**
 * 	Action to mark notifications as read
 *
 * 	@method POST
 */

export function readNotifications() {
    return {
        type: 'FETCH_POST_NOTIFICATIONS',
        payload: fetch(`/notification/mark`, { method: 'POST' }),
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/actions/notifications.ts